export const SUMMARY_FIELDS = [
   
        {
        key: "AR_Code",
        label: "รหัสลูกหนี้",
        w: "10%",
        alignHeader: "center",
        align: "center",
        numeric: false,
        sortable: true,
    },
    {
        key: "AR_Name",
        label: "ชื่อลูกหนี้",
        w: "60%",
        alignHeader: "center",
        align: "left",
        numeric: false,
        sortable: true,
    },

   
        {
        key: "paid",
        label: "ชำระแล้ว",
        w: "10%",
        alignHeader: "center",
        align: "end",
        numeric: false,
        sortable: true,
    },
     {
        key: "unpaid",
        label: "ค้างจ่าย",
        w: "10%",
        alignHeader: "center",
        align: "end",
        numeric: false,
        sortable: true,
    },
    {
        key: "NetTotalRaw",
        label: "ยอดรวม",
        w: "10%",
        alignHeader: "end",
        align: "end",
        numeric: true,
        sortable: true,
    },
];

export const DETAIL_FIELDS = [
    {
        key: "Doc_Date",
        label: "วันที่",
        w: "12%",
        alignHeader: "center",
        align: "center",
        numeric: false,
    },
    {
        key: "Doc_No",
        label: "เลขที่เอกสาร",
        w: "8%",
        alignHeader: "center",
        align: "center",
        numeric: false,
        sortable: true,
    },
    {
        key: "DocType_Name",
        label: "ประเภท",
        w: "8%",
        alignHeader: "center",
        align: "center",
        numeric: false,
        sortable: true,
    },

        {
        key: "DocStatusPaid_Type_Name",
        label: "ประเภทการจ่าย",
        w: "8%",
        alignHeader: "center",
        align: "center",
        numeric: false,
        sortable: true,
    },
        {
        key: "DocStatusPaid_Name",
        label: "สถานะการจ่าย",
        w: "8%",
        alignHeader: "center",
        align: "center",
        numeric: false,
        sortable: true,
    },
    {
        key: "NetTotal",
        label: "ราคารวม",
        w: "8%",
        alignHeader: "center",
        align: "end",
        numeric: true,
    },
];
